import React, { useCallback } from 'react';
import { FunctionComponent, HTMLAttributes } from 'react';
import { Legend } from '../Label';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { RequiredStrategy } from '../../Form';

export type HtmlFieldsetProps = React.DetailedHTMLProps<
    React.FieldsetHTMLAttributes<HTMLFieldSetElement>,
    HTMLFieldSetElement
> & {
    label?: string;
    requiredStrategy?: RequiredStrategy;
    required?: boolean;
};

export const HtmlFieldset: FunctionComponent<HtmlFieldsetProps> = ({
    label,
    children,
    className,
    required = false,
    requiredStrategy = 'required',
    ...props
}) => {
    const OptionalLegend = useCallback(() => {
        if (label) {
            return (
                <Legend required={required} requiredStrategy={requiredStrategy}>
                    {label}
                </Legend>
            );
        }

        return null;
    }, [label, required, requiredStrategy]);

    return (
        <fieldset
            className={classNames(styles.fieldset, className)}
            {...props}
            aria-required={required}
            aria-label={label}
        >
            <OptionalLegend />
            {children}
        </fieldset>
    );
};
